import React, { forwardRef } from 'react';
import styles from './FormInput.module.css';

const FormInput = forwardRef(({
    label,
    type = 'text',
    name,
    value,
    onChange,
    error,
    required = false,
    placeholder,
    disabled = false,
    className = '',
    style = {},
    icon,
    helpText,
    ...props
}, ref) => {
    const inputId = `input-${name}`;

    return (
        <div className={`${styles.container} ${className}`} style={style}>
            {label && (
                <label htmlFor={inputId} className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}

            <div className={styles.inputWrapper}>
                <input
                    ref={ref}
                    id={inputId}
                    type={type}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    required={required}
                    className={`${styles.input} ${error ? styles.hasError : ''}`}
                    {...props}
                />
                {icon && <span className={styles.icon}>{icon}</span>}
            </div>

            {helpText && !error && (
                <div className={styles.helpText}>
                    {helpText}
                </div>
            )}

            {error && (
                <div className={styles.error} role="alert">
                    {error}
                </div>
            )}
        </div>
    );
});

FormInput.displayName = 'FormInput';

export { FormInput };
export default FormInput;
